// path: src/utils/progression.js

const LS_MAX_LEVEL_KEY = "mmu_max_level";
const LS_BASE_GAME_COMPLETED_KEY = "mmu_base_game_completed_v1";

// Challenging = first 3x3 level => Level 4
export const CHALLENGING_START_LEVEL = 4;

// Hard = first 4x4 level => Level 7
export const HARD_START_LEVEL = 7;

// These match App.js `levels[].threshold` exactly.
const LEVEL_THRESHOLDS = [4, 8, 12, 21, 30, 39, 55, 71, 87, 103];

// Score you should have at the *start* of a level:
// Level 1 => 0
// Level 2 => 4
// Level 3 => 8
// Level 4 => 12
// ...
export function scoreAtStartOfLevel(levelNumber) {
    if (levelNumber <= 1) return 0;
    const prev = LEVEL_THRESHOLDS[levelNumber - 2];
    return Number.isFinite(prev) ? prev : 0;
}

export function getMaxUnlockedLevel() {
    const raw = window.localStorage.getItem(LS_MAX_LEVEL_KEY);
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}

export function setMaxUnlockedLevel(levelNumber) {
    const current = getMaxUnlockedLevel();
    const next = Math.max(current, levelNumber);
    window.localStorage.setItem(LS_MAX_LEVEL_KEY, String(next));
    return next;
}

export function isChallengingUnlocked() {
    return getMaxUnlockedLevel() >= CHALLENGING_START_LEVEL;
}

export function isHardUnlocked() {
    return getMaxUnlockedLevel() >= HARD_START_LEVEL;
}

export function markBaseGameCompleted() {
    window.localStorage.setItem(LS_BASE_GAME_COMPLETED_KEY, "true");
}

export function clearBaseGameCompleted() {
    window.localStorage.removeItem(LS_BASE_GAME_COMPLETED_KEY);
}

export function isTwistedModeUnlocked() {
    return window.localStorage.getItem(LS_BASE_GAME_COMPLETED_KEY) === "true";
}

export function isShyCorgisUnlocked() {
    return isTwistedModeUnlocked();
}